window.NMCLI = window.NMCLI || {};

window.NMCLI.escapeHtml = function(str) {
  if (!str) return '';
  const div = document.createElement('div');
  div.textContent = String(str);
  return div.innerHTML;
};

window.NMCLI.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || window.theme?.moneyFormat || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision || 2;
    thousands = thousands || ',';
    decimal   = decimal || '.';

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsStr   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + centsStr;
  }

  var match = formatString.match(placeholderRegex);
  if (!match) return '$' + formatWithDelimiters(cents, 2);

  switch(match[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
};

window.NMCLI.trapFocusHandlers = {};

window.NMCLI.trapFocus = function(element, namespace = 'default') {
  const focusableEls = element.querySelectorAll('a[href], button:not([disabled]), textarea, input, select');
  if (focusableEls.length === 0) return;

  const firstFocusableEl = focusableEls[0];
  const lastFocusableEl = focusableEls[focusableEls.length - 1];

  window.NMCLI.trapFocusHandlers[namespace] = function(e) {
    if (e.key !== 'Tab') return;

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }
  };

  element.addEventListener('keydown', window.NMCLI.trapFocusHandlers[namespace]);
  // Focus the first element on open
  setTimeout(() => { firstFocusableEl.focus(); }, 100);
};

window.NMCLI.removeTrapFocus = function(element, namespace = 'default') {
  if (window.NMCLI.trapFocusHandlers[namespace]) {
    element.removeEventListener('keydown', window.NMCLI.trapFocusHandlers[namespace]);
    delete window.NMCLI.trapFocusHandlers[namespace];
  }
};

function initCarousels(root = document) {
  const carousels = root.querySelectorAll('.carousel-wrapper');

  carousels.forEach(wrapper => {
    // Prevent double initialization
    if (wrapper.dataset.carouselInitialized === 'true') return;
    wrapper.dataset.carouselInitialized = 'true';

    const container = wrapper.querySelector('.carousel-container');
    const prevBtns = wrapper.querySelectorAll('.carousel-prev');
    const nextBtns = wrapper.querySelectorAll('.carousel-next');

    if (!container) return;

    const scrollByItem = (direction) => {
      const items = Array.from(container.children);
      const containerScroll = container.scrollLeft;
      
      let closestIndex = 0;
      let minDistance = Infinity;
      
      items.forEach((item, index) => {
        // Find which item is currently closest to the left edge
        const distance = Math.abs(item.offsetLeft - containerScroll);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });
      
      let targetIndex = direction === 'next' ? closestIndex + 1 : closestIndex - 1;
      
      // Keep target within bounds
      targetIndex = Math.max(0, Math.min(targetIndex, items.length - 1));
      
      const targetItem = items[targetIndex];

      if (targetItem) {
        // Native scrolling handles CSS scroll snapping perfectly
        targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    };

    prevBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        scrollByItem('prev');
      });
    });

    nextBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        scrollByItem('next');
      });
    });
  });
}

// Run on initial page load
document.addEventListener('DOMContentLoaded', () => {
  initCarousels();
  initScrollReveal();
});

// Run when a section is dynamically loaded in the Shopify Theme Editor
document.addEventListener('shopify:section:load', (event) => {
  initCarousels(event.target);
  initScrollReveal(event.target);
});

function initScrollReveal(root = document) {
  const elements = root.querySelectorAll('.reveal-up');

  if (!('IntersectionObserver' in window)) {
    // Fallback for older browsers
    elements.forEach(el => el.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        // Stop observing once revealed to prevent re-triggering
        obs.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '0px 0px -100px 0px',
    threshold: 0
  });

  elements.forEach(el => {
    if (!el.classList.contains('is-revealed')) {
      observer.observe(el);
    }
  });
}

// Global Wishlist Engine & Sync
function getWishlist() {
  try {
    const cached = localStorage.getItem('op_wishlist');
    if (!cached) return [];
    const parsed = JSON.parse(cached);
    if (!Array.isArray(parsed)) return [];
    const filtered = parsed.filter(handle => handle && typeof handle === 'string' && handle.trim() !== '');
    if (parsed.length !== filtered.length) {
      localStorage.setItem('op_wishlist', JSON.stringify(filtered));
    }
    return filtered;
  } catch (e) {
    return [];
  }
}


function toggleWishlist(handle) {
  let wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index > -1) {
    wishlist.splice(index, 1);
  } else {
    wishlist.push(handle);
  }
  localStorage.setItem('op_wishlist', JSON.stringify(wishlist));
  
  // Dispatch custom event to notify other modules
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
  updateWishlistUI();
}

function updateWishlistUI() {
  const wishlist = getWishlist();
  
  // Update all wishlist toggle buttons on the current page
  const buttons = document.querySelectorAll('[data-wishlist-button]');
  buttons.forEach(btn => {
    const handle = btn.getAttribute('data-wishlist-button');
    const icon = btn.querySelector('.wishlist-icon');
    const isSaved = wishlist.includes(handle);
    
    if (isSaved) {
      if (icon) {
        icon.innerText = 'favorite';
        icon.style.fontVariationSettings = "'FILL' 1";
      }
      btn.classList.add('text-red-500');
      btn.classList.remove('text-northern-navy');
      
      // For product page custom button
      if (btn.classList.contains('product-page-wishlist')) {
        const textSpan = btn.querySelector('.wishlist-text-span');
        if (textSpan) textSpan.innerText = 'Saved to Wishlist';
        btn.classList.add('border-red-500/30', 'text-red-500');
        btn.classList.remove('border-antique-gold/30', 'text-northern-navy');
      }
    } else {
      if (icon) {
        icon.innerText = 'favorite_border';
        icon.style.fontVariationSettings = "'FILL' 0";
      }
      btn.classList.remove('text-red-500');
      btn.classList.add('text-northern-navy');
      
      // For product page custom button
      if (btn.classList.contains('product-page-wishlist')) {
        const textSpan = btn.querySelector('.wishlist-text-span');
        if (textSpan) textSpan.innerText = btn.getAttribute('data-default-text') || 'Add to Wishlist';
        btn.classList.remove('border-red-500/30', 'text-red-500');
        btn.classList.add('border-antique-gold/30', 'text-northern-navy');
      }
    }
  });

  // Update Header Wishlist Badges
  const countEl = document.getElementById('header-wishlist-count');
  const countMobileEl = document.getElementById('mobile-wishlist-count');
  const iconEl = document.getElementById('header-wishlist-icon');
  
  if (countEl) {
    countEl.innerText = wishlist.length;
    if (wishlist.length > 0) {
      countEl.classList.remove('scale-0');
      countEl.classList.add('scale-100');
      if (iconEl) {
        iconEl.style.fontVariationSettings = "'FILL' 1";
        iconEl.classList.add('text-antique-gold');
      }
    } else {
      countEl.classList.remove('scale-100');
      countEl.classList.add('scale-0');
      if (iconEl) {
        iconEl.style.fontVariationSettings = "'FILL' 0";
        iconEl.classList.remove('text-antique-gold');
      }
    }
  }
  
  if (countMobileEl) {
    countMobileEl.innerText = wishlist.length;
    if (wishlist.length > 0) {
      countMobileEl.classList.remove('hidden');
    } else {
      countMobileEl.classList.add('hidden');
    }
  }
}

// Expose globally so inline onclick events can call them
window.getWishlist = getWishlist;
window.toggleWishlist = toggleWishlist;
window.updateWishlistUI = updateWishlistUI;

// Listen for wishlist:updated dispatched from secondary pages (like wishlist page removal)
document.addEventListener('wishlist:updated', () => {
  updateWishlistUI();
});

// Run initial UI updates on DOM load
document.addEventListener('DOMContentLoaded', () => {
  updateWishlistUI();
});

// Joy Loyalty Program trigger for #joy-rewards links
document.addEventListener('click', (e) => {
  const joyLink = e.target.closest('a[href*="#joy-rewards"]');
  if (joyLink) {
    e.preventDefault();
    if (window.joyInstance && typeof window.joyInstance.openWidget === 'function') {
      window.joyInstance.openWidget();
    } else {
      console.warn("Joy Loyalty widget script is not fully loaded or active yet.");
    }
  }
});

// Global Product Card Image Navigation (Desktop)
window.navigateCardImage = function(btn, dir) {
  const group = btn.closest('.group');
  if (!group) return;
  const link = group.querySelector('.desktop-card-link');
  if (!link) return;
  const img = link.querySelector('.desktop-card-image');
  if (!img) return;
  const images = JSON.parse(link.getAttribute('data-images') || '[]');
  if (!images.length) return;
  
  let index = parseInt(link.getAttribute('data-current-index') || '0', 10);
  index = (index + dir + images.length) % images.length;
  img.src = images[index];
  img.removeAttribute('srcset');
  link.setAttribute('data-current-index', index);
};

